import {
  // Alert,
  LinearProgress,
} from '@mui/material';
import React from 'react';
import { useOutlet } from 'react-router-dom';
import useStore from '../states/store';

export default function AuthLayout() {
  const outlet = useOutlet();
  const hasHydrated = useStore((state) => state.hasHydrated);

  return hasHydrated ? <div>{outlet}</div> : <LinearProgress />;
}
